import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';
import { getFeatureTogglesKey } from './cacheKeys';

export type UseFeatureTogglesReturnValue = {
    featureToggles: APITypes.featureToggleService.FeatureTogglesMeResponse;
    isLoadingFeatureToggles: boolean;
};

export default function useFeatureToggles(): UseFeatureTogglesReturnValue {
    const featureTogglesQuery = useQuery({
        queryKey: getFeatureTogglesKey(),
        queryFn: async () => {
            try {
                const res = await appAPI.get(urls.api.featureToggles.me);
                return res;
            } catch (error) {
                // Feature toggles aren't mission critical.
                // If there is some sort of error just toggle everything off
                return {};
            }
        },
        // 10 minutes
        staleTime: 10 * 60 * 1000,
    });

    return {
        featureToggles: featureTogglesQuery.data ?? {},
        isLoadingFeatureToggles: featureTogglesQuery.isLoading,
    };
}
